// login button component.
import React from 'react';
import pca from '../azureAuth';
import { FluxButton } from '@meltwater/flux-web-components-react';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import logger from '../utils/logger';

const AuthButton = (props) => {
    
    const login = async (event) => {  
        try {
          await pca.loginRedirect({
            scopes: ['openid', 'profile', 'email'],
            redirectStartPage: window.location.href,
          });
        } catch (error) {
          logger.error('Microsoft SSO redirect failed:', error);
        }
      };
        return (
          <FluxButton
            tint="primary"
            type="filled"
            onClick={login}
            style={{
              minWidth: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              padding: '10px 16px',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <MicrosoftIcon style={{ fontSize: '20px', display: 'block' }} />
              <span style={{ whiteSpace: 'nowrap' }}>Login with Microsoft</span>
            </span>
          </FluxButton>
        );
    };
export default AuthButton;
